<app-page-header title="Host details"></app-page-header>
<div class="row">
  <div class="col-md-4">
    <app-host-general-info [data]="generalDetails"></app-host-general-info>
  </div>

  <div class="col-md-4">
    <app-host-account [data]="accountInfo"></app-host-account>
  </div>

  <div class="col-md-4">
    <app-host-trip-route-details [data]="generalDetails"></app-host-trip-route-details>
  </div>
</div> 

<div class="height-15"></div>

<div class="height-15"></div>

<div class="height-15"></div>

<div class="row">
  <div class="col">
    <app-host-order-details *ngIf="toggleableDetails === 'Order Details'" class="width-100" [captainMobile]="mobileNumber" [captainId]="id" [hostDetailsToggleableHeaders] ="hostDetailsToggleableHeaders"
       (toggleHeaders)="headersToggled($event)"></app-host-order-details>
    <app-host-wallet-transactions *ngIf="toggleableDetails === 'Wallet Transactions'" class="width-100" [profileId]="id" [hostDetailsToggleableHeaders]="hostDetailsToggleableHeaders"
       (toggleHeaders)="headersToggled($event)"></app-host-wallet-transactions>
    <app-host-referral-rewards *ngIf="toggleableDetails === 'Referral Rewards'" class="width-100" [profileId]="id" [hostDetailsToggleableHeaders]="hostDetailsToggleableHeaders"
       (toggleHeaders)="headersToggled($event)"></app-host-referral-rewards>
  </div>
</div> 